<template>
  <e-chart
    ref="chart"
    :key="chartKey"
    :options="chartOptions"
    autoresize
    :style="`height: ${height}; width: ${width};`"
  />
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
import { capitalizeFirstLetter } from '@/composables/useCapitalizeFirstLetter.js'

export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    width: {
      type: String,
      default: '520px',
    },
    height: {
      type: String,
      default: '400px',
    },
    emptyVariant: {
      type: Boolean,
      default: false,
    },
    piePosition: {
      type: Array,
      default: () => ['50%', '50%'],
    },
    legendPosition: {
      type: Object,
      default: () => { return { right: 10 } },
    },
    emphasis: {
      type: Object,
      default: () => {
        return {
          padding: [10, 20],
          fontSize: '18',
        }
      },
    },
  },
  components: {
    'e-chart': ECharts,
  },
  data: () => ({
    chartKey: 1,
  }),
  watch: {
    items: {
      handler() {
        this.chartKey += 1
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    chartOptions() {
      const options = {
        title: {
          text: `Total ${this.items.reduce((sum, item) => {
            return sum + item.items.reduce((sumItemsValue, el) => {
              return sumItemsValue + el.value
            }, 0)
          }, 0)}`,
          left: this.piePosition[0],
          top: this.piePosition[1].includes('%')
            ? `${parseFloat(this.piePosition[1]) - 2}%`
            : `${parseInt(this.piePosition[1]) - 10}`,
          textAlign: 'center',
          textVerticalAlign: 'middle',
          textStyle: {
            fontSize: this.emphasis.fontSize,
            fontWeight: 'bold',
            color: '#333',
          },
        },
        series: [
          {
            silent: true,
            name: 'Status',
            type: 'pie',
            radius: ['50%', '70%'],
            center: this.piePosition,
            minAngle: 5,
            avoidLabelOverlap: false,
            hoverAnimation: false,
            z: 10,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2,
            },
            label: {
              show: false,
              position: 'center',
              formatter: ({ data }) => {
                let str = ''
                data.items.forEach((item, index) => {
                  str += `${item.name}: ${item.value}${data.items.length === index + 1 ? '' : '\n'}`
                })
                return str
              },
            },
            labelLine: {
              show: false,
            },
            data: this.items,
          },
        ],
      }
      if (this.emptyVariant) {
        return options
      }

      options.series[0].silent = false
      options.series[0].hoverAnimation = true
      options.series[0].emphasis = {
        label: {
          backgroundColor: '#fff',
          padding: this.emphasis.padding,
          show: true,
          fontSize: this.emphasis.fontSize,
          fontWeight: 'bold',
        },
      }

      return {
        legend: {
          orient: 'vertical',
          ...this.legendPosition,
          top: 'center',
          icon: 'roundRect',
          textStyle: {
            fontSize: 16,
            color: '#333',
            textTransform: 'capitalize',
          },
          itemWidth: 14,
          itemHeight: 14,
          data: this.items.map(i => i.name),
          formatter: (status) => {
            return capitalizeFirstLetter(status)
          },
        },
        ...options,
      }
    },
  },
}
</script>
